import React from 'react';
import IconBase from './Icon-base';
export default class ToggleComments extends React.Component {
    render() {
        return (
            <IconBase width="37" height="30" viewBox="0 0 37 30" {...this.props}>
                <g id="Canvas_tgc" transform="translate(-405 235)">
                    <g id="Group 2_tgc">
                        <g id="Line 3_tgc">
                            <use
                                xlinkHref="#path0_stroke_tgc"
                                transform="translate(415 -228.333)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Line 3.1_tgc">
                            <use
                                xlinkHref="#path0_stroke_tgc"
                                transform="translate(415 -222.5)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rectangle_tgc">
                            <mask id="mask0_outline_ins_tgc">
                                <use
                                    xlinkHref="#path1_fill_tgc"
                                    fill="white"
                                    transform="translate(411 -235)"
                                />
                            </mask>
                            <g mask="url(#mask0_outline_ins_tgc)">
                                <use
                                    xlinkHref="#path2_stroke_2x_tgc"
                                    transform="translate(411 -235)"
                                    fill="#4F5056"
                                />
                            </g>
                        </g>
                        <g id="Rectangle_tgc">
                            <use
                                xlinkHref="#path3_stroke_tgc"
                                transform="translate(406 -230)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Back Button_tgc">
                            <use
                                xlinkHref="#path4_fill_tgc"
                                transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 442 -212)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path id="path0_stroke_tgc" d="M 0 0L 12 0L 12 -1L 0 -1L 0 0Z" />
                    <path
                        id="path1_fill_tgc"
                        d="M 0 3C 0 1.34315 1.34315 0 3 0L 18 0C 19.6569 0 21 1.34315 21 3L 21 15.5185C 21 17.1754 19.6569 18.5185 18 18.5185L 15.6429 18.5185L 11 25L 6.35714 18.5185L 3 18.5185C 1.34315 18.5185 0 17.1754 0 15.5185L 0 3Z"
                    />
                    <path
                        id="path2_stroke_2x_tgc"
                        d="M 6.35714 18.5185L 7.17009 17.9362C 6.9823 17.674 6.67962 17.5185 6.35714 17.5185L 6.35714 18.5185ZM 11 25L 10.1871 25.5823L 11 26.7172L 11.8129 25.5823L 11 25ZM 15.6429 18.5185L 15.6429 17.5185C 15.3204 17.5185 15.0177 17.674 14.8299 17.9362L 15.6429 18.5185ZM 3 1L 18 1L 18 -1L 3 -1L 3 1ZM 20 3L 20 15.5185L 22 15.5185L 22 3L 20 3ZM 1 15.5185L 1 3L -1 3L -1 15.5185L 1 15.5185ZM 6.35714 17.5185L 3 17.5185L 3 19.5185L 6.35714 19.5185L 6.35714 17.5185ZM 11.8129 24.4177L 7.17009 17.9362L 5.54419 19.1009L 10.1871 25.5823L 11.8129 24.4177ZM 18 17.5185L 15.6429 17.5185L 15.6429 19.5185L 18 19.5185L 18 17.5185ZM 14.8299 17.9362L 10.1871 24.4177L 11.8129 25.5823L 16.4558 19.1009L 14.8299 17.9362ZM -1 15.5185C -1 17.7277 0.790861 19.5185 3 19.5185L 3 17.5185C 1.89543 17.5185 1 16.6231 1 15.5185L -1 15.5185ZM 20 15.5185C 20 16.6231 19.1046 17.5185 18 17.5185L 18 19.5185C 20.2091 19.5185 22 17.7277 22 15.5185L 20 15.5185ZM 18 1C 19.1046 1 20 1.89543 20 3L 22 3C 22 0.790861 20.2091 -1 18 -1L 18 1ZM 3 -1C 0.790861 -1 -1 0.790861 -1 3L 1 3C 1 1.89543 1.89543 1 3 1L 3 -1Z"
                    />
                    <path
                        id="path3_stroke_tgc"
                        d="M 6.23332 17.7778L 6.63685 17.4825C 6.54269 17.3538 6.39279 17.2778 6.23332 17.2778L 6.23332 17.7778ZM 10.7858 24L 10.3822 24.2952L 10.7858 24.8468L 11.1893 24.2952L 10.7858 24ZM 0.5 14.7778L 0.5 3L -0.5 3L -0.5 14.7778L 0.5 14.7778ZM 6.23332 17.2778L 3 17.2778L 3 18.2778L 6.23332 18.2778L 6.23332 17.2778ZM 11.1893 23.7048L 6.63685 17.4825L 5.8298 18.073L 10.3822 24.2952L 11.1893 23.7048ZM 3 0.5L 4.90262 0.5L 4.90262 -0.5L 3 -0.5L 3 0.5ZM 14.5965 17.9448L 10.3822 23.7048L 11.1893 24.2952L 15.4035 18.5352L 14.5965 17.9448ZM -0.5 14.7778C -0.5 16.7108 1.067 18.2778 3 18.2778L 3 17.2778C 1.61929 17.2778 0.5 16.1585 0.5 14.7778L -0.5 14.7778ZM 0.5 3C 0.5 1.61929 1.61929 0.5 3 0.5L 3 -0.5C 1.067 -0.5 -0.5 1.067 -0.5 3L 0.5 3Z"
                    />
                    <path
                        id="path4_fill_tgc"
                        fillRule="evenodd"
                        d="M 7 1.14286L 5.88 0L 0 5.94257L 5.88 12L 7 10.8571L 2.24 5.94257L 7 1.14286Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/ToggleComments.js